module.exports = __webpack_public_path__ + "icon-blue-copy___8ZD3a.svg";